/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import RedactorEditor from '../RedactorEditor';

import uuid from 'uuid/v4';

const BackCatalogue = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'BackCatalogue',
    title: { en: '' },
    mainSubTitle: { en: '' },
    bgColor: '#ECECE7',
    sort: 'asc',
    elements: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [showOptions, setShowOptions] = useState(false);
  const [updatedData, setUpdatedData] = useState(false);
  const [elements, setElements] = useState([]);

  const [title, setTitle] = useState({'en': ''});
  const [mainSubTitle, setMainSubTitle] = useState({ en: '' });
  const [bgColor, setBgColor] = useState('#ECECE7');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          title: currentTitle,
          mainSubTitle: currentMainSubTitle,
          bgColor: currentBgColor,
          elements: currentElements,
        } = component;

        setState(component);
        setTitle(currentTitle);
        setMainSubTitle(currentMainSubTitle);
        setBgColor(currentBgColor);
        setElements(currentElements);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      title,
      mainSubTitle,
      bgColor,
      elements,
    }

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title,
    mainSubTitle,
    bgColor,
    updatedData,
    activeLanguage,
  ]);

  const titleChange = (e) => {
    const itemIndex = e.target.getAttribute('itemindex');
    const { name, value } = e.target;
    elements[itemIndex][name][activeLanguage] = value
    setElements(elements);
    setUpdatedData(uuid());
  }

  const titleChangeFromRedactor = (value, itemIndex) => {
    //const itemIndex = e.target.getAttribute('itemindex');
    elements[itemIndex]['text'][activeLanguage] = value
    setElements(elements);
    setUpdatedData(uuid());
  }

  const pushAnItemToElements = () => {
    elements.push({
      title: { en: '' },
      mainSubTitle: { en: '' },
      subtitle: { en: '' },
      image: { en: '' },
      text: { en: '' },
      itemId: elements.length + 1
    })
    setElements(elements);
    setUpdatedData(uuid());
  }

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    switch (source.droppableId) {
      // origin same as destination, order elements
      case destination.droppableId: {
        //const newOrder = reorder(elements, source.index, destination.index);
        [elements[source.index], elements[destination.index]] = [elements[destination.index], elements[source.index]];


        setElements(elements);
        setUpdatedData(uuid());
        break;
      }

      default: {
        break;
      }
    }
  };

  const removeFromElements = (indexOfElement) => {
    elements.splice(indexOfElement, 1);
    setElements(elements);
    setUpdatedData(uuid());
  };

  const titleTextChange = (e) => {
    title[activeLanguage] = e.target.value;
    setTitle({ ...title });
  };

  // NOTE: there is a bug in the RedactorEditor component as the language is not changing
  const mainSubtitleTextChange = (text) => {
    mainSubTitle[activeLanguage] = text;
    setMainSubTitle({ ...mainSubTitle });
    setUpdatedData(uuid());
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex flex-wrap my-4 text-black">
        <div className="flex-1 mr-4">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Title
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            onChange={titleTextChange}
            value={title[activeLanguage]}
          />
        </div>
        <div className="">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Background Color
                </label>
          <div className="relative">
            <input
              className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              type="text"
              onChange={e => setBgColor(e.target.value)}
              value={bgColor}
            />
            <input
              className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
              name="color"
              type="color"
              onChange={e => setBgColor(e.target.value)}
              value={bgColor}
            />
          </div>
        </div>
        <div className="w-full md:mb-0 text-black">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold my-2"
            >
            Subtitle
          </label>
          <RedactorEditor
            text={mainSubTitle?.[activeLanguage]}
            setText={mainSubtitleTextChange}
            id={`subtitle_${id}`}
          />
        </div>
      </div>
      <div className="flex justify-start flex-col text-black">
        <Droppable droppableId="selected">
          {(provided, snapshot) => (
            <div ref={provided.innerRef}
              className={`${snapshot.isDraggingOver ? 'bg-grey' : 'bg-grey-lighter'} min-h-30 mb-4 rounded w-full p-2 relative`}>
              {elements.map((element, index) => {
                const { title, subtitle, image, text, itemId = 0 } = element;
                return (
                  <Draggable
                    key={`${id}_${index}`}
                    draggableId={`${id}_${index}`}
                    index={index}
                    activeLanguage={activeLanguage}>
                    {(provided, snapshot, component) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`relative bg-gray-200 bg-white min-h-30 mb-2 rounded w-full p-2`}
                        style={provided.draggableProps.style}
                      >
                        <div className="flex flex-wrap mb-2">
                          <div className="bg-grey-light cursor-pointer font-bold mr-1 p-2 px-4 rounded text-center">{index + 1}</div>
                          <div className="bg-grey-light cursor-pointer text-center flex-2 p-2 rounded" {...provided.dragHandleProps}> =</div>
                          <div className="cursor-pointer p-2 rounded" onClick={() => removeFromElements(index)}><span className="font-icon icon-close-btn1" /></div>
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Image
                        </label>
                          <input
                            className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            itemindex={index}
                            name="image"
                            type="text"
                            onChange={titleChange}
                            value={image[activeLanguage]}
                          />
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Title
                        </label>
                          <input
                            className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            type="text"
                            itemindex={index}
                            name="title"
                            onChange={titleChange}
                            value={title[activeLanguage]}
                          />
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Sub Title
                        </label>
                          <input
                            className="appearance-none block
                      bg-gray-200 text-gray-700 border border-red-500
                      rounded py-3 px-4 w-full leading-tight focus:outline-none
                      focus:bg-white"
                            itemindex={index}
                            name="subtitle"
                            type="text"
                            onChange={titleChange}
                            value={subtitle[activeLanguage]}
                          />
                        </div>
                        <div className="w-full md:w-full md:mb-0 mt-2">
                          <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          >
                            Text
                        </label>
                          <RedactorEditor
                            text={text[activeLanguage]}
                            setText={(text) => titleChangeFromRedactor(text, index)}
                            id={`${id}_${itemId}`}
                          />
                        </div>
                      </div>
                    )}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>

          )}

        </Droppable>


        <div className="hover:bg-blue-light hover:text-white rounded w-full">
          <div
            className={`block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500 text-center`}
            onClick={pushAnItemToElements}
          >+</div>
        </div>
      </div>
    </DragDropContext>
  );
};

BackCatalogue.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
BackCatalogue.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default BackCatalogue;
